<rt-button
  #dropdownOrigin="rtOverlayOrigin"
  rt-overlay-origin
  [rtWalkthroughOriginStepId]="'walkthrough-step-proceed-disqualify-3'"
  [rtWalkthroughOriginBeforeRender]="beforeWalkthroughTooltipRender | fnBind: this : stageDropdown"
  [rtWalkthroughOriginAfterDispose]="afterWalkthroughTooltipDispose | fnBind: this : stageDropdown"
  variant="primary"
  size="small"
  [dropdownOpened]="stageDropdown.open"
  [attr.category]="stage()?.category ?? 'none'"
  (click)="toggleDropdown(stageDropdown)"
  [class.pressed]="stageDropdown.open"
  data-cy="candidate-profile:placement:stage-menu-button"
>
  @if (stage()?.group === StageGroup.Hires) {
    <rt-icon name="hired" size="small-x" />
  }
  <rt-truncate min-width-0>
    {{ stage()?.name ?? '' }}
  </rt-truncate>
</rt-button>

<ng-template
  #stageDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="dropdownOrigin"
  (backdropClick)="toggleDropdown(stageDropdown)"
>
  <rt-candidate-stage-menu
    [dropdownRef]="stageDropdown"
    [stagesWithProgress]="stagesWithProgress()"
    [placement]="placement()"
    [canProceed]="placementActions().proceed"
    (closeClick)="toggleDropdown(stageDropdown)"
    (stageClick)="
      proceedClick.emit({
        placement: placement(),
        targetStage: $event.stage,
        originStage: stage(),
        eventOrigin: 'stage-select',
      })
    "
    (showDetailsClick)="
      showAutomatedActionDetailsClick.emit({
        placement: placement(),
        actionAssignedStage: $event,
      })
    "
  />
</ng-template>
